import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { goBackOrHome } from '@/lib/navHelpers';
import MindBodyInsights from '@/components/insights/MindBodyInsights';
import { AppHeader } from '@/components/AppHeader';
import { User } from '@supabase/supabase-js';

export default function MindBodyInsightsPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    loadUser();
  }, []);

  const loadUser = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    setUser(user);
  };

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/auth');
  };

  return (
    <div className="min-h-screen bg-background animate-fade-in">
      <AppHeader user={user} onSignOut={handleSignOut} />
      
      <div className="p-6">
        <div className="max-w-6xl mx-auto space-y-6">
          {user && (
            <Button 
              variant="ghost" 
              size="sm" 
               onClick={() => goBackOrHome(navigate)} 
               className="mb-4 hover:bg-accent/10 transition-colors"
             >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Dashboard
            </Button>
          )}

          <MindBodyInsights />
        </div>
      </div>
    </div>
  );
}
